import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface FeedbackConversationData {
  chatSessionId?: string;
  feedbackId: number;
  userRequest?: string;
  feedbackDetails?: any;
  selectedTabIndex?: number;
  selectedEvaluationTabIndex?: number;
  targetEvaluationTabLabel?: string;
  hideConversationTab?: boolean;
  evaluationOnly?: boolean;
}

@Component({
    selector: 'app-feedback-conversation-tabs',
    templateUrl: './feedback-conversation-tabs.component.html',
    styleUrls: ['./feedback-conversation-tabs.component.scss'],
    standalone: false
})
export class FeedbackConversationTabsComponent {
  chatSessionId: string;
  feedbackId: number;
  userRequest: string;
  feedbackDetails: any;
  selectedTabIndex = 0;
  selectedEvaluationTabIndex?: number;
  targetEvaluationTabLabel?: string;
  hideConversationTab = false;
  evaluationOnly = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: FeedbackConversationData,
    private dialogRef: MatDialogRef<FeedbackConversationTabsComponent>
  ) {
    this.chatSessionId = data.chatSessionId;
    this.feedbackId = data.feedbackId;
    this.userRequest = data.userRequest;
    this.feedbackDetails = data.feedbackDetails;
    this.selectedTabIndex = data.selectedTabIndex || 0;
    this.selectedEvaluationTabIndex = data.selectedEvaluationTabIndex;
    this.targetEvaluationTabLabel = data.targetEvaluationTabLabel;
    this.hideConversationTab = data.hideConversationTab || false;
    this.evaluationOnly = data.evaluationOnly || false;

    // If evaluation only, force to evaluation tab and hide conversation tab
    if (this.evaluationOnly) {
      this.hideConversationTab = true;
      this.selectedTabIndex = 0; // Will be the only tab (evaluation)
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
